import axios from 'axios';

const API_USER_BASE_URL = "https://astronomic-network.herokuapp.com/user"
const API_MATCHING_CRITERIA_BASE_URL = "https://astronomic-network.herokuapp.com/matching"
const API_PAYMENTS_BASE_URL = "https://astronomic-network.herokuapp.com/plan"
const API_FEEDBACK_BASE_URL = "https://astronomic-network.herokuapp.com/feedback"
const API_SEARCH_CITY_URL = "https://an-cities-api.herokuapp.com/api";
const API_VERIFY_EMAIL_URL = "https://astronomic-network.herokuapp.com/email";

const call = {
  users_API: {
    login: async (email, password) => {
      let response = await axios.post(API_USER_BASE_URL + "/login", {
        email: email,
        password: password,
      });
      return response.data;
    },
    createAccount: async (name, lastname, email, password) => {
      let response = await axios.post(API_USER_BASE_URL + "/create", {
        name: name,
        lastname: lastname,
        email: email,
        password: password,
      });
      return response.data;
    },
    finishCreatingAccount: async (user_type, city, policy_agreements) => {
      let {
        no_sharing_information,
        being_professional_policy,
      } = policy_agreements;

      let response = await axios.post(
        API_USER_BASE_URL + "/signup/finish",
        {
          user_type: user_type,
          city: city,
          policy_agreements: {
            no_sharing_information: no_sharing_information,
            being_professional_policy: being_professional_policy,
          },
        },
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    },
    updateUser: async (user_body) => {
      let response = await axios.post(
        API_USER_BASE_URL + "/update",
        user_body,
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    },
    getPersonalUserMatchingCriteria: async () => {
      let response = await axios.get(
        API_USER_BASE_URL + "/account/personal/criterias",
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    },
    setCity: async (city) => {
      let response = await axios.get(
        API_USER_BASE_URL + "/signup?city=" + city,
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    },
    changePassword: async (oldPassword, newPassword) => {
      let response = await axios.post(
        `${API_USER_BASE_URL}/account/password/reset`,
        {
          old_password: oldPassword,
          new_password: newPassword,
        },
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    },
  },
  matching_criteria_API: {
    createMatchingCriteria: async (matching_criteria) => {
      // { REQUEST BODY STRUCTURE
      //     "industry": "Aerospace",
      //     "industry_importance": true,
      //     "revenue_range": {
      //      "min": 12000 ,
      //      "max": 15000
      //    },
      //    "match_comparable_revenues":true,
      //    "nearest_buissnes_goal":1,
      //    "account_links":{
      //        "meeting_scheluder":"http://calendar",
      //        "linkedin":"test test",
      //        "company_website":"www.website.com"
      //    },
      //    "meeting_days":[
      //        {
      //            "day":"Monday",
      //            "starting_hour":12,
      //            "ending_hour":1,
      //            "hour_clock":"AM"
      //        },
      //        {
      //            "day":"Weekdays",
      //            "starting_hour":8,
      //            "ending_hour":9,
      //            "hour_clock":"PM"
      //        },
      //        {
      //            "day":"Thursday",
      //            "starting_hour":12,
      //            "ending_hour":1,
      //            "hour_clock":"AM"
      //        }
      //    ]
      //  }
      let response = await axios.post(
        API_MATCHING_CRITERIA_BASE_URL + "/create",
        matching_criteria,
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    },
    updateMatchingCriteria: async (matching_criteria) => {
      // {
      //     "industry": "Agriculture",
      //     "industry_importance": true,
      //     "revenue_range": {
      //      "min": 12000 ,
      //      "max": 15000
      //    },
      //    "match_comparable_revenues":true,
      //    "nearest_buissnes_goal":1,
      //    "account_links":{
      //        "meeting_scheluder":"http://calendar",
      //        "linkedin":"test test",
      //        "company_website":"www.website.com"
      //    },
      //    "meeting_days":[
      //        {
      //            "day":"Monday",
      //            "starting_hour":12,
      //            "ending_hour":1,
      //            "hour_clock":"AM"
      //        },
      //        {
      //            "day":"Weekdays",
      //            "starting_hour":8,
      //            "ending_hour":9,
      //            "hour_clock":"PM"
      //        },
      //        {
      //            "day":"Thursday",
      //            "starting_hour":12,
      //            "ending_hour":1,
      //            "hour_clock":"AM"
      //        }
      //    ]
      //  }

      let response = await axios.post(
        API_MATCHING_CRITERIA_BASE_URL + "/update",
        matching_criteria,
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    },
  },
  payments: {
    subscribe: async (payment_method) => {
      let response = await axios.post(
        API_PAYMENTS_BASE_URL + "/subscribe",
        payment_method,
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    },
    getSubscriptionForUser: async () => {
      let response = await axios.get(
        API_PAYMENTS_BASE_URL + "/subscription/list",
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    },
    cancelSubscription: async () => {
      let response = await axios.get(
        API_PAYMENTS_BASE_URL + "/subscription/cancel",
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    },
  },
  feedback: {
    sendFeedback: async (feedbackObj) => {
      let response = await axios.post(
        API_FEEDBACK_BASE_URL + "/give",
        feedbackObj,
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      );
      return response.data;
    },
  },
  cities: {
    searchCity: async (name) => {
      let response = await axios.get(`${API_SEARCH_CITY_URL}/search/${name}`, {
        headers: {
          token: localStorage.getItem("token"),
        },
      });
      return response.data;
    },
    verifyCity: async (city, subcountry, country) => {
      let response = await axios.post(`${API_SEARCH_CITY_URL}/verify`, {
        city,
        subcountry,
        country,
      });
      return response.data;
    },
  },

  mail: {
    verifyEmail: async (userID, verificationCode) => {
      let response = await axios.get(
        `${API_VERIFY_EMAIL_URL}/verify?id=${userID}&verification_code=${verificationCode}`
      );
      return response.data;
    },
    resendEmail: async (userID) => {
      let response = await axios.get(
        `${API_VERIFY_EMAIL_URL}/resend?id=${userID}`
      );
      return response.data;
    },
  },
};

export default call;
